/**
 * @fileoverview スプリットテスト（A / B テスト）のパターン切り替えを行うコンポーネント
 * @description
 *  使用側（親コンポーネント）で、パターンのキーとなる名称の slot 名でコンテンツを注入し、
 *  props で表示するキー名を指定するか、props 無指定の場合は URL のクエリから表示キーの文字列があるか検索して表示する。
 */
<script lang="ts">
import {
  defineComponent,
  useSlots,
  ref,
  onMounted,
  nextTick,
  type VNode,
} from 'vue'
import { UrlUtil } from '@/utilities/url'

export default defineComponent({
  name: 'SplitTestWrapper',

  props: {
    /**
     * パターンのキーとなる名称
     * @description
     *  パターンを直接指定する場合は、この props に「表示する slot の slot 名と同じ文字列」を渡す。
     *  未指定の場合は、URL のクエリから同一の slot 名が存在するか探索して表示する。
     */
    pattern: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const patternKeyName = ref('')

    const slots = useSlots()

    // レンダリング完了フラグ
    const rendered = ref(false)

    const slotNodes = ref<VNode[]>([])

    onMounted(() => {
      const slotKeys = Object.keys(slots)
      if (props.pattern) {
        if (slotKeys.includes(props.pattern)) {
          patternKeyName.value = props.pattern
        }
      } else {
        const url = new UrlUtil()
        patternKeyName.value = url.getQueryKeys().find(v => slotKeys.includes(v)) || ''
      }

      // パターンが指定されておらず、且つ URL のクエリにもパターンが存在しない場合はデフォルト指定がなければランダムで抽出する
      if (!patternKeyName.value && !slots.default) {
        const max = slotKeys.length
        patternKeyName.value = slotKeys[Math.floor(Math.random() * max)]
      }

      nextTick(() => {
        const slotFn = patternKeyName.value
          ? slots[patternKeyName.value]
          : slots.default || undefined
        slotNodes.value = slotFn ? slotFn() : []

        rendered.value = true

        if (!slotNodes.value.length) {
          console.error('Unexpected Error: No slot nodes found.')
        }
      })
    })

    return {
      // data
      slots,
      rendered,
      slotNodes,
    }
  }
})
</script>

<template>
  <template v-if="rendered && slotNodes.length">
    <template
      v-for="(vnode, i) in slotNodes"
      :key="vnode.key ?? i">
      <component :is="vnode" />
    </template>
  </template>
</template>
